export interface IUpdateObject {
    oldValue?: string;
    newValue?: string;
    confirm?: string;
}

export interface IForgotData {
    userId: string;
    cf: string;
    captcha: string;
    captchaId: string;
}

export interface IChallengeData {
    cf: string;
    userId: string;
    challengeAnswer?: string;
    challengeQuestion?: string;
    validEmail?: boolean;
    validAltEmail?: boolean;
    validSMS?: boolean;
    showPhoneWarning?: boolean;
}

export class ChallengeAnswer implements IChallengeData {
    constructor(
        public cf: string,
        public userId: string,
        public challengeAnswer: string,
        public channelToBeUsed: string,
        public tempUUID: string
    ) {
        this.cf = cf ? cf : null;
        this.userId = userId ? userId : null;
        this.challengeAnswer = challengeAnswer ? challengeAnswer : null;
        this.channelToBeUsed = channelToBeUsed ? channelToBeUsed : null;
        this.tempUUID = tempUUID ? tempUUID : null;
    }
}

export class ChallengeQuestion implements IChallengeData {
    constructor(
        public cf: string,
        public userId: string,
        public challengeQuestion: string,
        public validEmail: boolean,
        public validAltEmail: boolean,
        public validSMS: boolean,
        public showPhoneWarning: boolean,
        public tempUUID: string
    ) {
        this.cf = cf ? cf : null;
        this.userId = userId ? userId : null;
        this.challengeQuestion = challengeQuestion ? challengeQuestion : null;
        this.validEmail = validEmail ? validEmail : false;
        this.validAltEmail = validAltEmail ? validAltEmail : false;
        this.validSMS = validSMS ? validSMS : false;
        this.showPhoneWarning = showPhoneWarning ? showPhoneWarning : false;
        this.tempUUID = tempUUID ? tempUUID : null;
    }
}

export class UpdateObject implements IUpdateObject {
    constructor(public oldValue?: string, public newValue?: string, public confirm?: string) {
        this.oldValue = oldValue ? oldValue : null;
        this.newValue = newValue ? newValue : null;
        this.confirm = confirm ? confirm : null;
    }
}

export class ForgotData implements IForgotData {
    constructor(public cf: string, public userId: string, public captcha: string, public captchaId: string) {
        this.cf = cf;
        this.userId = userId;
        this.captcha = captcha;
        this.captchaId = captchaId;
    }
}
